export const createTreeCategories = (list) => {
  let result = []
  list.forEach(item => {
    if (!item.parentCategory || item.parentCategory === '') {
      item.children = []
      result.push(item)
    }
  })
  result = recursiveTree(result, list)
  return convertirId(result)
}

function recursiveTree (children, list) {
  children.forEach((item, index) => {
    let result = list.filter(element => element.parentCategory === item._id)
    if (result) {
      children[index].children = recursiveTree(result, list)
    }
  })
  return children
}

function convertirId (list) {
  let content = []
  list.forEach(item => {
    item.id = item._id
    if (item.children) {
      item.children = convertirId(item.children)
    }
    content.push(item)
  })
  return content
}

export const treeForSelect = (nivel = 1, tree) => {
  let list = []
  let guion = '-- '.repeat(nivel - 1)
  tree.forEach(function (item) {
    list.push(
      {
        text: guion + item.name,
        value: item._id
      }
    )
    if (item.children.length > 0) {
      let items = treeForSelect(nivel + 1, item.children)
      items.forEach(element => list.push(element))
    }
  })
  return list
}
